import React from 'react';
import { Badge } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import { EMPTY } from '../../lib/format';

/**
 * The vocabulary of «صفحات پزشکان», in one place.
 *
 * Statuses are the practitioner service's closed set
 * (`doctorpage.proto` AdminPageRow.status). An unknown value arriving from the
 * wire is echoed raw, never mislabelled as a known one (the proto zero-value
 * rule).
 */
export const PAGE_STATUSES = ['published', 'suspended', 'unpublished', 'draft'];

/** Rows per page, server-side (`doctorPages(limit, offset)`). */
export const DOCTOR_PAGE_SIZE = 50;

/** Mirrors the admin BFF's REASON_MIN / REASON_MAX. */
export const REASON_MIN = 3;
export const REASON_MAX = 500;

/**
 * What an operator may do to a page in each status (design §7.1):
 * published | unpublished → suspended; suspended → unpublished. A draft was
 * never public, so there is nothing to take down.
 */
export const PAGE_ACTIONS = {
  published: 'suspend',
  unpublished: 'suspend',
  suspended: 'restore',
  draft: null,
};

export const actionFor = (status) => PAGE_ACTIONS[status] || null;

const TONE = {
  published: 'success',
  unpublished: 'outline',
  draft: 'outline',
  suspended: 'destructive',
};

export function PageStatusBadge({ status, 'data-testid': testId }) {
  const { t, has } = useTranslation();
  if (!status) return <span>{EMPTY}</span>;
  const key = `doctorPages.status.${status}`;
  const label = has && has(key) ? t(key) : String(status);
  const tone = TONE[status] || 'outline';
  return <Badge variant={tone} data-tone={tone} data-testid={testId}>{label}</Badge>;
}
